/** Izanami flags (`FeatureType.Dynamic`), prefixed with the brand by `FeatureFlipRepository`. */
export enum DynamicFeaturesEnum {
  /** Checked per distributor (`context: { id: distributorId }`). */
  PRODUCT_MANAGEMENT = 'seller:product-management',
}
